"use strict";

exports.__esModule = true;
exports.ScheduleForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _ScheduleFormBody = require("./ScheduleFormBody");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows a form which can edit a schedule.
 */
var ScheduleForm = exports.ScheduleForm = /*#__PURE__*/function (_Component) {
  function ScheduleForm() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleSubmit = function (input) {
      var onSubmit = _this.props.onSubmit;
      return onSubmit(input);
    };
    _this.handleValidate = function (input) {
      var errors = {};
      if (!input.name) {
        errors.name = "Name is required";
      }
      if (!input.interval || !input.interval.startMillis) {
        errors.interval.startMillis = "Start time is required";
      }
      return errors;
    };
    return _this;
  }
  _inheritsLoose(ScheduleForm, _Component);
  var _proto = ScheduleForm.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      calendarConfig = _this$props.calendarConfig,
      scheduleConfig = _this$props.scheduleConfig;
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      onSubmit: this.handleSubmit,
      mutators: _finalFormArrays["default"],
      validate: this.handleValidate,
      initialValues: scheduleConfig
    }, function (props) {
      return /*#__PURE__*/_react["default"].createElement(_ScheduleFormBody.ScheduleFormBody, _extends({}, props, {
        calendarConfig: calendarConfig
      }));
    });
  };
  return ScheduleForm;
}(_react.Component);
ScheduleForm.defaultProps = {
  translator: undefined
};